import { render, staticRenderFns } from "./CodePopup.vue?vue&type=template&id=0004b54d&scoped=true"
import script from "./CodePopup.vue?vue&type=script&lang=js"
export * from "./CodePopup.vue?vue&type=script&lang=js"
import style0 from "./CodePopup.vue?vue&type=style&index=0&id=0004b54d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0004b54d",
  null
  
)

export default component.exports